module.exports = __webpack_public_path__ + "img/list_bsk.47275d47.jpg";